import React from 'react';

import classes from './Toolbar.module.css';
import NavigationItems from '../NavigationItems/NavigationItems';
import DrawerToggle from '../SideDrawer/DrawerToggle/DrawerToggle';

const toolbar = ( props ) => (
    <header className={classes.Toolbar}>
        <DrawerToggle clicked={props.sideDrawerToggleClicked} />
        <nav className={classes.DesktopOnly}>
            <NavigationItems
                isAuthenticated={props.isAuth}
                userId={props.userId}
                accountId={props.accountId}
                userPermissions={props.userPermissions}
                notifications={props.notifications}
                toggleSearch={props.toggleSearch}
                toggleGamesSearch={props.toggleGamesSearch}
                toggleHelp={props.helpDrawerToggleClicked}
                userClicked={props.userDrawerToggleClicked}
                userEditOpen={props.userEditOpen}
                sideDrawerClosed={props.sideDrawerClosed}
                location={props.location}
                openLogin={props.openLogin}
                openMiscSearch={props.openMiscSearch}
                openNotifications={props.openNotifications}
                isInToolbar={true}
                token={props.token}
            />
        </nav>
    </header>
);

export default toolbar;